import styled from '@emotion/styled';

const IconCardStyle = styled.div`
  min-width: 275px;
  min-height: 275px;
  border-radius: 10px;
  border: solid 3px #dddddd;
  display: flex;
  justify-content: center;
  text-align: center;
  padding: 20px 8px 0px 8px;

  .icon-card {
    img {
      height: 100px;
    }
    .title {
      color: ${(props: any) => props.theme.palette.primary.dark};
      font-size: 20px;
    }

    .content {
      margin-top: 5px;
      color: ${(props: any) => props.theme.palette.primary.light};
      font-size: 16px;
    }
  }

  ${(props: any) => props.theme.breakpoints.down('lg')} {
    padding: 0px 50px;
    align-items: center;
    min-width: 356px;
    min-height: 356px;
  }

  ${(props: any) => props.theme.breakpoints.down('md')} {
    padding: 0px 16px;
    min-width: 290px;
    min-height: 290px;
  }
`;

export default IconCardStyle;
